var table_viewer_default = {
  "viewMode": "DTLxS",
  "editMode": "wIaKq",
  "container": "tidOw",
  "cell": "NAvn4"
};
export {
  table_viewer_default as default
};
//# sourceMappingURL=table-viewer-scss.js.map
